import { getService } from 'data/function';
// State names
import { tenantStateName } from '../../application/tenant';
import { artificialIntelligenceStateName } from '../../application/detail/ai';
import { deskMicrofrontStateName } from '../../application/detail/attendance';
import { EventAction } from '../EventAction';
export class StateChangeProcessor {
    static get $state() {
        return getService('$state');
    }
    static get $location() {
        return getService('$location');
    }
    /**
     * Process stateChange event action from postMessage
     */
    static process({ message }) {
        if (message.content.type == EventAction.StateChangeSuccess) {
            StateChangeProcessor.$state.go(message.content.to, message.content.toParams);
        }
        else if (message.content.type == EventAction.ChangeLocation) {
            StateChangeProcessor.$location.search(message.content.toParams);
            StateChangeProcessor.$location.replace();
        }
        else if (message.content.type == EventAction.ChangePath) {
            StateChangeProcessor.$location.path(message.content.path);
        }
        else {
            window.scrollTo(0, 0);
            const path = ['blip-ai', 'blip-desk'].includes(message.caller)
                ? message.content.toFullUrl.slice(1)
                : message.content.toUrl.slice(1);
            const app = message.content.app;
            const notify = message.content.notify || false;
            let state;
            switch (app || message.caller) {
                case 'blip-tenant':
                    state = tenantStateName;
                    break;
                case 'blip-ai':
                    state = artificialIntelligenceStateName;
                    break;
                case 'blip-desk':
                    state = deskMicrofrontStateName;
                    break;
            }
            if (state !== undefined) {
                StateChangeProcessor.$state.go(state, { path, raw: true }, { notify });
            }
        }
    }
}
